var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e62348f1c7455184cde680fa9c839dacce1b4ba1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["circular-react@circular-exchange"]={id:"e62348f1c7455184cde680fa9c839dacce1b4ba1"};
      